import profile from '../../data/profile/profile.json';
import './footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="container footer__inner">
      <p className="footer__copy">
        © {new Date().getFullYear()} {profile.name} · Made with care. 🌏❤️
      </p>
    </div>
  </footer>
);

export default Footer;
